<!-- NOTICE -->
<template>
    <div>
        <!-- // * CONTENT TITLE -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <span v-if="form[collectionItem + 'Name'] === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form.id }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU (CUSTOM) -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>
                        </v-tabs>
                        <!-- // * TABS ITEMS -->                        
                        <v-tabs-items v-model="tabs" class="appbackground">
                            <!-- OVERVIEW -->                            
                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-4 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>                                                
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class="pa-0 d-flex pl-3 pr-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t(`buttons.destroy`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-fire" type="purple"  class="mr-1" @click.native="destroyItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="saveItem()" showlabel="xlOnly" />                                                
                                            </v-col>                    
                                        </v-row>
                                        <!-- // * FORM -->  
                                        <v-row class="mt-4 ma-0 px-3" no-gutters>
                                            <v-col class="pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-text-field :label="$t(`fields.id`)" v-model="form.id" filled hide-details :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>

                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">



                                                <vue-editor v-model="form.content" v-if="formMode === 'New' || formMode === 'Edit'"></vue-editor>
                                                <div v-html="form.content" v-if="formMode === 'View'"></div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapState, mapActions } from 'vuex'; // Map the Getters from the Vuex Store
    import { VueEditor } from "vue2-editor";
    export default {
        components: {
          VueEditor
        },
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'guides',
            collectionTitle: 'Notices',
            collectionItem: 'guide',
            collectionItemTitle: 'Notice',
            langPath: 'guides.guide',
            tabs: 'overview',
            // * FORM RELATED
            form: {
                content: null
            },
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_openItem: 'GET_openGuide', // Get Open guide Data
                GET_docUploadResult: 'docUpload_store/GET_docUploadResult', // GET docUpload Result
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure                
                GET_help: 'GET_help'                           
            }),
        },    
        // * WATCH
        watch: {
             // GET CONFIRMATION RESULT (CUSTOM)
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === 'guides') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteDocumentResult = await t.MIX_deleteDocument ('guides', t.GET_confirmBoxResult.data.id);
                            if (deleteDocumentResult.code === 1) {
                                t.MIX_alert(1, `Guide Deleted`, deleteDocumentResult.data, null);
                                t.refreshItemView();                            
                            } else {
                                t.MIX_alert(-1, `Error Deleting Guide`, null, null);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'guides/destroy') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var destroyDocumentResult = await t.MIX_destroyDocument ('guides', t.GET_confirmBoxResult.data.id);
                                if (destroyDocumentResult.code === 1) {
                                t.MIX_alert(1, `Guide Destroyed`, destroyDocumentResult.data, null);
                                t.MIX_setPanelLayout(12, 0, false, '', '');
                            } else {
                                t.MIX_alert(-1, `Error Destroying Guide`, null, null);
                            }
                        }
                    } else {
                        // Do nothing
                    }
                }, deep: true
            },
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openNotice'}),            
            // UPDATE BREADCRUMBS (GENERIC)
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data.id }`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM  (GENERIC)
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New': 
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }              
                return;
            },
            // EDIT ITEM  (GENERIC)
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM  (GENERIC)
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.refreshItemView();      
                t.closeRightPanel();  
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // SAVE ITEM (GENERIC)
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // UPDATE ITEM STATUS (GENERIC)
            updateItemStatus: async function(status) {
                var t = this;
                // console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                // console.log('updateResult.code = ' + updateResult.code)
                var type = ['App', 'Email'];
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                    // // * CREATE NOTIFICATIONS CALL
                    // t.MIX_createNotification( type, 'Update Document', 'warning', 'Click to Update the Document.', 'Update Document', '/guides/' + t.form.id);
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error); 
                }
            },
            // REFRESH ITEM VIEW (GENERIC)
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD (GENERIC)
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`, 
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
            // UNDELETE ITEM METHOD (GENERIC)
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    var unDeleteLinkedResult = await t.MIX_undeleteLinked (['files'],  t.form.id)                    
                    if (unDeleteLinkedResult.code === 1) {
                        t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
                    } else {
                        t.MIX_alert(-1, `Error Restoring File Record`, null, unDeleteFileResult.error);
                    }
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                    // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },
            // DESTROY ITEM METHOD (CUSTOM)
            destroyItem: async function() {
                var t = this
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'guides/destroy',
                        id: t.form.id,
                        title: `Destroy Notice`, 
                        description: `Are you sure you want to destroy the guide: <br /><strong>${t.form.id}</strong>?`, 
                        width: '300',
                        height: '300',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )     
            },            
        },        
        // * MOUNTED
        async mounted() {
            var t = this;
            
            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            t.formMode = openItem.process; // Show Form in View Mode
            if (openItem.process === 'New') { 
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
                t.tabs = 'overview';                
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details    
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.tabs = 'overview';
            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title
        }
    }
</script>

<style scoped>
    .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
    .v-tabs-items{
        width: 100% !important;
        height: 100% !important;
    }
    .v-window-item {
        height: calc(100vh - 170px); 
        overflow-y: auto;
    }    
</style>